import type { EffectParams } from '../../types';

const effects = {
  async getActiveGames(_payload: void, params: EffectParams) {
    const { dispatch } = params;

    dispatch.activeGames.set();
  }
};

export default effects;
